

import Vue from "vue";
import Crm from "@/models/crm/crm";
import AppContactSearch from "@/components/contacts/ContactSearchWithBrowseAndCreate.vue";
import { Contact } from "@/models/base";

export default Vue.extend({
	data(){
		return {
			contactGroupId: 1
		};
	},
	props: {
		crm: {
			required: true,
			type: Object as () => Crm
		},
	},
	computed: {},
	methods: {
		selectContact(contact: Contact){
			this.crm.Contact = contact;
			this.crm.ContactID = contact.ID;
		}
	},
	components: {
		AppContactSearch,
	},
	i18nEx: {
		componentPrefix: "components.crm"
	}
});
	